import React  from "react"
import { Link } from "gatsby"
import styled from 'styled-components'
import scrollTo from 'gatsby-plugin-smoothscroll'

import MainLogo from '../svgs/white-lion-logo.svg'

const LandingPageHeader = () => {

    return(
        <MainHeader className={"sticky-header"} id="sticky_vTwo">
            <HeaderFlex>
                <Logo>
                    <Link to="/">
                        <MainLogo 
                        data-sal="slide-down"
                        data-sal-duration="1000"
                        data-sal-easing="ease"
                        data-sal-delay="0"
                        />
                    </Link>
                </Logo>
                <button 
                onClick={() => scrollTo('#i2i_contact')}
                data-sal="slide-down"
                data-sal-duration="1000"
                data-sal-easing="ease"
                data-sal-delay="300"
                >Book Your Strategy Session</button>
            </HeaderFlex>
        </MainHeader>
    );

}

const MainHeader = styled.header`
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    padding: 20px 0;
    border-top: 20px solid #fff;
    background-color: #fff;
    z-index: 100;
    box-shadow: 0 0px 0px #fff;
    button {
        font-family: "Work Sans";
        font-size: 20px;
        line-height: 1;
        font-weight: 700;
        color: rgb(255, 255, 255);
        text-decoration: none;
        background-color: rgb(219, 65, 64);
        display: inline-block;
        padding: 20px 50px;
        margin: 0;
        border: none;
        outline: 0;
        &:hover {
            cursor: pointer;
        }
    }
    @media(max-width:1100px) {
        border-top: 0px solid #fff !important;
        padding: 10px 0 !important;
    }
`

const HeaderFlex = styled.nav`
    max-width: 1360px;
    width: 100%;
    padding: 0 20px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    @media(max-width: 767px) {
        justify-content: center;
        button {
            display: none;
        }
    }
`

const Logo = styled.div`
    max-width: 200px;
    width: 100%;
    transition-duration: .3s;
    @media(max-width:1100px) {
        max-width: 154px;
        height: 40px;
    }
`

export default LandingPageHeader